import Vue from 'vue'
import template from './_email-modal.pug'
import ProfileService from 'js/services/api/profile'

export default Vue.extend({
  name: 'EmailModal',
  template: template(),
  props: {
    value: Boolean
  },
  data() {
    return {
      code: '',
      sending: false,
      loading: false
    }
  },
  methods: {
    async sendCode() {
      this.sending = true
      try {
        await ProfileService.sendCode2FA()
        this.$notifications?.success(this.$t('profile.auth2faSettings.email.codeSent'))
      } catch {
        this.$notifications?.error(this.$t('profile.auth2faSettings.email.error'))
      } finally {
        this.sending = false
      }
    },

    async verifyCode() {
      if (!this.code) {
        this.$notifications?.error(this.$t('profile.auth2faSettings.email.codeRequired'))
        return
      }

      this.loading = true
      try {
        await ProfileService.verify2FA({
          email: this.$user.email || '',
          twofacode: this.code,
          method2faAuth: 'email'
        })
        await ProfileService.toggle2FA({
          enableTwoFactor: true,          
          method2faAuth: 'email'
        })
        this.$notifications?.success(this.$t('profile.auth2faSettings.modals.totp.success'))
        this.$emit('success')
        this.$emit('close')
      } catch {
        this.$notifications?.error(this.$t('profile.auth2faSettings.modals.totp.error'))
      } finally {
        this.loading = false
      }
    }
  }
})
